/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LadderResponse } from './LadderResponse';
import {
    LadderResponseFromJSON,
    LadderResponseFromJSONTyped,
    LadderResponseToJSON,
    LadderResponseToJSONTyped,
} from './LadderResponse';

/**
 * 
 * @export
 * @interface UpdateLadderResponse
 */
export interface UpdateLadderResponse {
    /**
     * 
     * @type {LadderResponse}
     * @memberof UpdateLadderResponse
     */
    ladder: LadderResponse;
}

/**
 * Check if a given object implements the UpdateLadderResponse interface.
 */
export function instanceOfUpdateLadderResponse(value: object): value is UpdateLadderResponse {
    if (!('ladder' in value) || value['ladder'] === undefined) return false;
    return true;
}

export function UpdateLadderResponseFromJSON(json: any): UpdateLadderResponse {
    return UpdateLadderResponseFromJSONTyped(json, false);
}

export function UpdateLadderResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLadderResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'ladder': LadderResponseFromJSON(json['ladder']),
    };
}

export function UpdateLadderResponseToJSON(json: any): UpdateLadderResponse {
    return UpdateLadderResponseToJSONTyped(json, false);
}

export function UpdateLadderResponseToJSONTyped(value?: UpdateLadderResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ladder': LadderResponseToJSON(value['ladder']),
    };
}

